import dayjs from 'dayjs'
import sortBy from 'lodash/sortBy'

const sortByStartTime = campaignBudgets =>
  sortBy(campaignBudgets, b => dayjs(b.startTime).unix())
const filterBy = (
  campaignBudgets,
  { insertionOrderBudgetId, insertionOrderBudgetRequestId },
) =>
  insertionOrderBudgetId
    ? campaignBudgets.filter(
        b => b.insertionOrderBudgetId === insertionOrderBudgetId,
      )
    : campaignBudgets.filter(
        b => b.insertionOrderBudgetRequestId === insertionOrderBudgetRequestId,
      )
const filterByInsertionOrderBudget = (campaignBudgets, insertionOrderBudget) =>
  insertionOrderBudget.isApproved
    ? filterBy(campaignBudgets, {
        insertionOrderBudgetId: insertionOrderBudget.id,
      })
    : filterBy(campaignBudgets, {
        insertionOrderBudgetRequestId: insertionOrderBudget.latestRequest.id,
      })

const filterVisible = campaignBudgets => campaignBudgets.filter(b => !b.deleted)

export const getCampaignBudgets = (campaignBudgets, insertionOrderBudget) =>
  sortByStartTime(
    filterVisible(
      filterByInsertionOrderBudget(campaignBudgets, insertionOrderBudget),
    ),
  )

export default getCampaignBudgets
